import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import { Button, FinancieraLogo, OfertaCardData } from "@components/ui_v2";

const NOTA_TEXT = "#5C6B7C";
const DIALOG_SCRIM = "rgba(6, 44, 78, 0.55)";

interface Props {
  oferta: OfertaCardData;
  disabled: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Última confirmación antes de mandar la oferta a formalización: a diferencia del modal de
 * la pantalla de preofertas, aquí se advierte que la decisión ya no se puede cambiar solo.
 */
export const DialogConfirmarHandoff = ({ oferta, disabled, onConfirm, onClose }: Props) => (
  <Dialog
    open
    onClose={onClose}
    fullWidth
    PaperProps={{ sx: { maxWidth: 460, borderRadius: "18px", boxShadow: "0 24px 64px rgba(6, 44, 78, 0.35)" } }}
    slotProps={{ backdrop: { sx: { bgcolor: DIALOG_SCRIM, backdropFilter: "blur(4px)" } } }}
  >
    <DialogContent sx={{ p: "30px 28px" }}>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 40, mb: "18px" }}>
        <FinancieraLogo logo={oferta.logo} financiera={oferta.financiera} maxHeight={40} maxWidth="70%" />
      </Box>

      <Typography sx={{ fontWeight: 600, fontSize: 20, color: "primary.dark", textAlign: "center", mb: "10px" }}>
        ¿Confirmar tu oferta con {oferta.financiera}?
      </Typography>
      <Typography
        sx={{
          fontSize: 14.5,
          lineHeight: 1.55,
          color: NOTA_TEXT,
          textAlign: "center",
          mb: "24px",
          "& strong": { color: "primary.dark" },
        }}
      >
        Esta decisión es <strong>definitiva</strong>: las demás preofertas serán <strong>rechazadas</strong>. Si después
        quieres cambiar, tendrás que comunicarte con un ejecutivo de Pymio.
      </Typography>

      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Button
          tone="outline"
          fullWidth
          disabled={disabled}
          onClick={onClose}
          data-testid="oferta-seleccionada-dialog-cancel-button"
        >
          Cancelar
        </Button>
        <Button
          tone="accent"
          fullWidth
          disabled={disabled}
          onClick={onConfirm}
          data-testid="oferta-seleccionada-dialog-confirm-button"
        >
          Sí, continuar
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);
